import * as types from "../constants/actionTypes";
import initialState from "./initialState";

const profileDataReducer = (state = initialState.profileData, action) => {
  switch (action.type) {
    case types.FETCH_VIEW_PROFILE_STARTED:
      return {
        ...state,
        isLoading: true,
        error: null
      };
    case types.FETCH_VIEW_PROFILE_SUCCEEDED:
      return {
        ...state,
        userProfile: action.payload,
        isLoading: false,
        error: null
      };
    case types.FETCH_VIEW_PROFILE_FAILED:
      return {
        ...state,
        isLoading: false,
        error: action.payload
      };
    default:
      return state;
  }
};

export default profileDataReducer;
